import IconBase, { type IconProps } from '../IconBase';
const Svg24X24CheckmarkBadgedFilled = (props: Omit<IconProps, 'children'>) => {
  return (
    <IconBase data-testid="checkmarkBadgedFilled" viewBox="0 0 24 24" {...props} width="24" height="24">
      <>
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m-1.143 13.777 5.85-5.85a.999.999 0 1 0-1.414-1.415l-4.436 4.436-2.15-2.15a.999.999 0 1 0-1.414 1.415z"
          clipRule="evenodd"
        />
      </>
    </IconBase>
  );
};
export default Svg24X24CheckmarkBadgedFilled;
